import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import useApi from '@/hooks/useApi';
import useApp from '@/pages/App.context';
import Spinner from '@/components/Spinner';
import NotFound from './NotFound';
import AcceptForm from './AcceptForm';
import styles from './InvitationWelcome.module.scss';

const InvitationWelcome = () => {
  const { t } = useTranslation(['invite']);
  const { setAppTitle } = useApp();
  const [searchParams] = useSearchParams();

  const [loadInvitation, { response, loading }] = useApi(
    'organization.invitation.get'
  );

  const InnerBox = (() => {
    if (loading) {
      return (
        <div className={styles.spinner}>
          <Spinner />
        </div>
      );
    }
    if (!response?.success) {
      return <NotFound />;
    }
    return (
      <AcceptForm
        companyName={response.data.invitedBy?.company ?? ''}
        inviterName={response.data.invitedBy?.name ?? ''}
      />
    );
  })();

  useEffect(() => {
    void loadInvitation({
      id: searchParams.get('invitationId') ?? 'invalid-id',
    });
  }, [loadInvitation, searchParams]);

  useEffect(() => {
    setAppTitle(t('invite:welcome.title'));
  }, [setAppTitle, t]);

  return (
    <>
      <h2 className={styles.heading}>{t('invite:welcome.title')}</h2>
      {InnerBox}
    </>
  );
};

export default InvitationWelcome;
